import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  validColor,
  invalidColor,
  noDataColor,
} from '../../utils/styleConst';

const ListStyle = styled.ul`
    color: #333;
    font-size: 13px;
    background-color: white;
    font-weight: 400;
    line-height: 1.4;

    li {

      :first-letter {
        text-transform:capitalize;
      }

      :first-child {
        font-size: 14px;
        font-weight: 500;
      }

      &.capacity {
        font-weight: 500;
        color: ${props => (props.free > 0 ? validColor : invalidColor)};

        &.no-data {
          color: ${noDataColor}
        }
      }

      a {
        color: #427fed;
        text-decoration: none;

        &:hover, &:focus, &:active {
          text-decoration: underline;
        }
      }

    }
`;

const List = ({ studio }) => {
  const {
    sensor,
    name,
    streetAddress,
    postalCode,
    addressLocality,
    capacity,
  } = studio;

  const hasData = sensor.length;
  const freePlaces = hasData && sensor[0].value;
  const isFree = freePlaces !== '0';

  return (
    <ListStyle free={isFree}>
      <li>{name}</li>
      <li>{streetAddress}, {postalCode} {addressLocality}</li>
      <li>Abri de {capacity} places</li>
      {hasData && sensor[0].state === 'ok' ? (
        <li className="capacity">{freePlaces} {freePlaces === 1 ? 'place restante' : 'places restantes' }</li>
      ) : (
        <li className="capacity no-data">Nombre de places: indisponible</li>
      )}
      <li><a target="_blank" href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(studio.streetAddress)},+${encodeURIComponent(studio.addressLocality)}`}>Voir dans Google Maps</a></li>
    </ListStyle>
  );
};

List.propTypes = {
  studio: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};
export default List;




// WEBPACK FOOTER //
// src/components/googleMap/List.jsx